export default __webpack_public_path__ + "static/desk02-452cfc014c348da428d20c72d2e25cf3.png";